import apiFetch from '../apiFetch'

export default function (idUbicacionVerraco, token) {
  return apiFetch({endPoint: `MovimientoVerraco/getMovimientoVerraco?idUbicacionVerraco=` + idUbicacionVerraco, method: 'GET', body: null, token: token})
}
